module.exports = __webpack_public_path__ + "static/media/google.86f37ef7.png";